import axios from 'axios';

const deleteTrustedSender = id => axios.delete(`owner/trusted-senders/${id}`);

const createTrustedSender = params => axios.post(`owner/trusted-senders/new`, params);

export { deleteTrustedSender, createTrustedSender };